import selectedColorBrand from "@/config/tailwind-colors/brand-colors";
import { PRODUCT } from "@/constants";

const defaultValues = {
  avanti: {
    isShow: true,
    bgColor: selectedColorBrand.dark["surface-accent-2-secondary"],
  },
  staysure: {
    isShow: true,
    bgColor: selectedColorBrand.dark["surface-info"],
  },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const isShowExclusiveBanner = defaultValues[brand];

export default isShowExclusiveBanner;
